import React, { HTMLProps } from 'react';

import UiInput from '../ui-input/ui-input';

import SearchIcon from './icons/search-icon.svg';

type UiSearchInputProps = HTMLProps<HTMLInputElement> & {
  leftIcon?: string;
  rightIcon?: string;
  label?: string;
  sm?: boolean;
  lg?: boolean;
};

// eslint-disable-next-line react/jsx-props-no-spreading
const UiSearchInput: React.FC<UiSearchInputProps> = (props) => (
  <UiInput leftIcon={SearchIcon} {...props} />
);

export default UiSearchInput;
